import { useMemo } from "react";
import {
  BulkStatus,
  IBulkCollaboratorBatch,
  IBulkCollaboratorItem
} from "@wingspanhq/payments/dist/interfaces";
import { getBulkQueriesByResource } from "../../query/bulkBatchResourceQueryMap";
import { BulkResource } from "../../types";
import { getUploadedFilename } from "../../utils/getUploadedFilename";
import { prepareCSVCollaboratorFromBatchItem } from "../../utils/prepareCSVCollaboratorFromBatchItem";
import { prepareCollaboratorCSVFile } from "../../utils/prepareCollaboratorCSVFile";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { queriesCustomFields } from "@query";

export function useDownloadErrorsCSV(
  bulkBatchId: string,
  bulkResource: BulkResource
) {
  const { useBulkBatch, useAllBulkBatchItems } =
    getBulkQueriesByResource(bulkResource);
  const queryBulkBatch = useBulkBatch(bulkBatchId);
  const queryCollaboratorCustomFields =
    queriesCustomFields.listCustomFields.useQueryAll({
      filter: { resourceType: { eq: CustomFieldResourceType.PAYEE } }
    });
  const collaboratorCustomFields = queryCollaboratorCustomFields.flatData;
  const queryAllFailedBulkBatchItems = useAllBulkBatchItems(
    bulkBatchId,
    {
      filter: {
        status: BulkStatus.Failed
      }
    },
    {
      enabled:
        (queryBulkBatch.data?.statistics?.itemsFailed || 0) > 0 ||
        queryBulkBatch.data?.status === BulkStatus.Failed
    }
  );

  const errorsCSVFileProps = useMemo(() => {
    const failedCSVCollaborators = (
      queryAllFailedBulkBatchItems.data ?? []
    ).map(failedBatchItem =>
      prepareCSVCollaboratorFromBatchItem(
        failedBatchItem as IBulkCollaboratorItem,
        collaboratorCustomFields,
        [],
        { includeErrors: true }
      )
    );
    const errorsCSVFileProps = prepareCollaboratorCSVFile(
      `Errors_${getUploadedFilename(
        queryBulkBatch.data as IBulkCollaboratorBatch,
        BulkResource.Collaborator
      )}`,
      collaboratorCustomFields,
      failedCSVCollaborators,
      { includeErrors: true }
    );

    return errorsCSVFileProps;
  }, [
    queryAllFailedBulkBatchItems.data,
    collaboratorCustomFields,
    queryBulkBatch.data
  ]);

  return { errorsCSVFileProps };
}
